import React, { Component } from 'react';
import { Image, Header, Grid, Button, Form, Label } from 'semantic-ui-react'
import axios from 'axios'
import Select from 'react-select';
import * as moment from 'moment';
import ReactPixel from 'react-facebook-pixel';
import {
    base, serverIp, ref, firebaseAuth, shirtSizes, orderSourceOptions,
    replacementOptions, replacementReasonOptions, orderTypeOptions, genderOptions,
    new_pixel_id, sendNewOrderSmsOptions,
} from '../../../config/constants.js'
import * as UiConsts from '../../../config/UiConstants'
import { getOrderNumberAndUpdateCounterNew, } from '../../../Utilities/FireBaseUtils'
import 'react-dates/initialize';
import { SingleOrderFromArray } from '../SingleOrderFromArray/SingleOrderFromArray';
import { ErrorMessages } from '../OrderFormComps'
import { getOrderNumberAndSaveOrder } from '../SaveOrderFunction/SaveOrderFunction';

import { checkAdminEmail } from '../../dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });

ReactPixel.init(new_pixel_id);

export class TemplateOrderForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            admin: false,
            itemSelected: 'template',
            template: '',
            formErrorFieldArray: [],

            shirtSize1: '',
            shirtType1: 'round_neck',
            shirtColor1: '',
            monthSelected1: '',

            shirtSize2: '',
            shirtType2: 'round_neck',
            shirtColor2: '',
            monthSelected2: '',

            shirtSize3: '',
            shirtType3: 'round_neck',
            shirtColor3: '',
            monthSelected3: '',

            //IF ITS TEH MONTH TEMPLATE
            monthTemplate: false,
            selectDateTemplate: false,

            shirtColors1: [],
            shirtColors2: [],
            shirtColors3: [],

            //SHIRT SIZES
            // shirtSizes:[],

            //(this.state.shirtColor3 != '' && this.state.shirtSize3 != '' && this.state.shirtType3 != '' && this.state.qty3 != ''

            //ORDER VISIBLE
            order2Visible: false,
            order3Visible: false,
            numOrders: 1,


            //template stuff
            templateGenericField1: '',
            templateGenericField2: '',
            templateGenericField3: '',


            templateSpecialFieldLabel: '',
            templateSpecialFieldLabel2: '',
            templateSpecialFieldLabel3: '',

            //STANDARD FORM PARTS.
            name: '',
            name: '',
            phone: '',
            phone2: '',
            email: '',
            address: '',
            special_instructions: '',
            adset: 'none',
            pricing_notes: '',
            formErrors: [],

            //TEMPLATE COMPONENTS
            templateComponents: [],

            ivanDescription: '',

            //SINIYA
            siniya: false,
            orderSource: '',
            replacement: '',
            replacementReason: '',

            //ad set
            adset: 'none',

            orderType: 'none',
            gender: 'none',
            sendNewOrderSms: 'yes',
            couponCode: '',
            salesPerson: '',
            salesPeopleChoices:[],
        }
    }

    componentDidMount = () => {
        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++:removeListener");


            if (user) {
                console.log("maddx241 user is:" + user.email);

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })
            }


        })



        this.loadTemplateDetails();

        //SHIRT COLORS
        base.fetch('shirtColors', {
            context: this,
            asArray: true,
            state: 'normalShirtColors',
            then(data) {
                //  console.log(data);
                this.setState({
                    shirtColors1: data,
                    shirtColors2: data,
                    shirtColors3: data
                })
            }
        });


        //SET FB CAMPAIGN NAME FROM URL..
        if (this.props.match.params.adset) {
            console.log("adset2 adset is valid:" + this.props.match.params.adset);

            this.setState({ adset: this.props.match.params.adset })
        } else {
            console.log("adset21 NO ADSET sent");
        }


    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));
        this.setState({
            algoliaUser: returnObject.algoliaUser,
            admin: returnObject.isAdmin,
            //isAdmin: returnObject.isAdmin,
        })

        if(returnObject.isAdmin){
            this.getSalesPeopleDropdown();
        }
    }

    getSalesPeopleDropdown() {
        console.log("salx1 +++++++++: getArtistInfo");
        axios.post(serverIp + 'salesApp/getSalesPeople', {
            apiKey: "123123"
        })
            .then((response) => {
                console.log("salx12:" + JSON.stringify(response.data, null, 3));
                this.setState({
                    loading: false,
                    salesPeopleChoices: response.data.dropdownItems
                })
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });
    }


    loadTemplateDetails = () => {
        axios.post(serverIp + 'templates/findTemplate', {
            apiKey: 'asdfasererr',
            templateId: this.props.match.params.templateId
        })
            .then((response) => {
                console.log("obx71:" + JSON.stringify(response.data, null, 3));

                //CHECK IF THE MONTH TEMPLATE
                if (response.data.template.itemCode === 'created_equal') {

                    this.setState({
                        template: response.data.template,
                        loading: false,
                        monthTemplate: true,
                        selectDateTemplate: false
                    })

                } else if (response.data.template.itemCode === 'faceShirt') {

                    this.setState({
                        template: response.data.template,
                        loading: false,
                        monthTemplate: true,
                        faceShirt: true,
                        selectDateTemplate: false
                    })

                } else {
                    this.setState({
                        template: response.data.template,
                        loading: false,
                        monthTemplate: false,
                        selectDateTemplate: true,
                        templateSpecialFieldLabel: response.data.template.itemDescription
                    })
                }

                //LOG TEMPLATE SELECTED
                if (response.data.template.ivanDescription) {
                    console.log("ivanDescription:" + response.data.template.ivanDescription);
                    let tempAdmin = false;

                    this.setState({
                        ivanDescription: response.data.template.ivanDescription
                    })

                    //SET ADMIN
                    if (this.state.admin) {
                        tempAdmin = true;
                    }


                }

                this.setState({
                    itemCode: response.data.template.ivanDescription
                })


                //load components..
                if (response.data.templateComponents) {
                    console.log("cxx1 components found:" + response.data.templateComponents.length);
                    console.log("cxx10 componentJson:" + JSON.stringify(response.data.templateComponents, null, 3));

                    this.setState({
                        templateComponents: response.data.templateComponents,
                        templateComponentComposite: response.data.templateComponentComposite,

                        //THE ITEM TYPE FOR TEMPLATE COMPONENTS IS SET HERE
                        //E.G SHIRTS FOR SHIRT, FOOTBALL FOR FOOTBALL
                        //THIS WILL ALLOW THE ADD MORE BUTTON TO ACTUALLY ADD MORE OF THE SAME TYPE
                        itemSelected: response.data.templateComponents[0].itemTypeRel.itemType
                    })
                    console.log("cxx11 itemSelected set to:" + response.data.templateComponents[0].itemTypeRel.itemType);
                } else {
                    console.log("cxx1 NO template components");
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    /**
   * MAKE THE NEXT ORDER SECTION VISIBLE
   */
    handleAddMoreClick = (orderChoice) => {
        console.log("++++++:handleAddMoreClick - orderChoice:" + orderChoice);

        if (orderChoice === 'Order 1') {
            let tempNumOrders = this.state.numOrders;
            tempNumOrders++;
            this.setState({
                order2Visible: true,
                numOrders: tempNumOrders
            });


        } else if (orderChoice === 'Order 2') {
            let tempNumOrders = this.state.numOrders;
            tempNumOrders++;
            this.setState({
                order3Visible: true,
                numOrders: tempNumOrders
            });

        } else {
            console.log("uknown orderChoice");
        }
    }

    /**
  * HANDLE DROPDOWN FOR ORDER ONE
  */
    handleOrderDetailsDropDownChangesOrderOne = (value) => {
        console.log("hdx1 handleOrderDetailsDropDownChangesOrderOne");
        console.log('hdx12 You\'ve sss:', value);
        console.log("hdx13 category alone:" + value.category);
        console.log("hdx14 category:" + value.category + '1');
        console.log('hdx15 You\'ve selected:', value.value + " " + value.category);
        console.log("hdx16 -  this.props.itemSelected:" + this.state.itemSelected);

        let newState = {};
        newState[value.category + '1'] = value.value;
        console.log("newState 1:" + JSON.stringify(newState));

        //this.setState(newState);
        this.setState(newState);
    }

    /**
* HANDLE DROPDOWN FOR ORDER TWO
*/
    handleOrderDetailsDropDownChangesOrderTwo = (value) => {
        console.log("hdx1 handleOrderDetailsDropDownChangesOrderTwo");
        console.log('hdx12 You\'ve sss:', value);
        console.log("hdx13 category alone:" + value.category);
        console.log("hdx14 category:" + value.category + '1');
        console.log('hdx15 You\'ve selected:', value.value + " " + value.category);
        console.log("hdx16 -  this.props.itemSelected:" + this.state.itemSelected);

        let newState = {};
        newState[value.category + '2'] = value.value;
        console.log("newState 2:" + JSON.stringify(newState));

        //this.setState(newState);
        this.setState(newState);
    }

    /**
* HANDLE DROPDOWN FOR ORDER TWO
*/
    handleOrderDetailsDropDownChangesOrderThree = (value) => {
        console.log("hdx1 handleOrderDetailsDropDownChangesOrderTwo");
        console.log('hdx12 You\'ve sss:', value);
        console.log("hdx13 category alone:" + value.category);
        console.log("hdx14 category:" + value.category + '3');
        console.log('hdx15 You\'ve selected:', value.value + " " + value.category);
        console.log("hdx16 -  this.props.itemSelected:" + this.state.itemSelected);

        let newState = {};
        newState[value.category + '3'] = value.value;
        console.log("newState 3:" + JSON.stringify(newState));

        //this.setState(newState);
        this.setState(newState);
    }

    /**
        * SAVE ORDER IN FIREBASE
        */
    saveOrder = () => {

        if (this.state.singleOrderArray) {
            //CHANGE UI
            //UPDATE  ORDER COMPLETE
            this.setState({
                // newPostKey: newPostKey,
                orderComplete: true,
                orderConfirming: false,
            });

            //ORIGINAL
            console.log("andx00 before calling..");
            getOrderNumberAndUpdateCounterNew(getOrderNumberAndSaveOrder, this.getNewOrderObjectForNewSaveFunction())

        } else {
            console.log("not all feilds filled in");
        }


    }

    amp_logFieldClick = (e) => {
        console.log("clx1 logClicked.....");
        console.log("hx32 e.target.name:" + e.target.name);

        var eventProperties = {
            'fieldClicked': e.target.name,
            admin: this.state.admin
        }

        console.log("clx12 fieldvar:" + JSON.stringify(eventProperties));

    }

    /**
     * GET NEW ORDER OBJEC TO PASS TO SAVE FUNCTION..
     */
    getNewOrderObjectForNewSaveFunction() {
        console.log("andx4 ++++++++ - getNewOrderObjectForNewSaveFunction");

        var d = new Date();
        var n = d.toString();
        let now = moment().format('MMMM Do YYYY, h:mm:ss a');

        // itemSelected, 
        // name, 
        // user,
        // numOrders
        // phone
        // phone2
        // address
        //shirtSizeAndQtys
        //singleOrderArray


        let orderObject = {
            templateId: this.state.template.idtemplates,
            itemSelected: this.state.itemSelected,
            user: this.state.user,
            name: this.state.name,
            admin: this.state.admin,
            numOrders: this.state.singleOrderArray.length,
            phone: this.state.phone,
            phone2: this.state.phone2,
            address: this.state.address,
            email: this.state.email,
            special_instructions: this.state.special_instructions,
            adset: this.state.adset,
            pricing_notes: this.state.pricing_notes,
            shirtSizeAndQtys: this.state.shirtSizeAndQtys,
            singleOrderArray: this.state.singleOrderArray,
            //DESIGN IMAGE
            designImageUrl: this.state.template.imageUrl,
            designUpdated: now,
            //shirt text
            shirtText: 'template - ' + this.state.template.idtemplates,
            shirtBackText: 'none',
            //date
            dateString: now,
            dateNum: d.getTime(),
            siniya: this.state.siniya,
            replacement: this.state.replacement,
            replacementReason: this.state.replacementReason,
            orderSource: this.state.orderSource,
            itemCode: this.state.template.itemCode,
            orderType: this.state.orderType,
            gender: this.state.gender,
            sendNewOrderSms: this.state.sendNewOrderSms,
            templateType: this.state.template.templateType.templateType,
            couponCode: this.state.couponCode,
            salesPerson: this.state.salesPerson,
        }

        // console.log("andx41 new order object:"+JSON.stringify(orderObject,null,3));
        return orderObject
    }

    /**
   * GET OBJECT OF THE ORDER
   */
    getNewOrderObject = (orderNum) => {

        var d = new Date();
        var n = d.toString();
        let now = moment().format('MMMM Do YYYY, h:mm:ss a');

        let tempOrderNum = orderNum ? orderNum : 'na';

        //CALC NUMBER OF ORDERS
        let tempNumOrders = this.state.numOrders;

        let newDescription = this.state.name + ' ordered ';

        // Ivan ordered 5 white large shirts

        let newOrder = {
            itemType: 'template',
            templateId: this.state.template.idtemplates,
            quantity: this.state.numOrders,
            email: this.state.email,
            orderEntryComplete: true,
            status: 'new',
            phone: this.state.phone,
            phone2: this.state.phone2,
            name: this.state.name,
            address: this.state.address,
            special_instructions: this.state.special_instructions,
            adset: this.state.adset,
            pricing_notes: this.state.pricing_notes,
            dateString: now,
            dateNum: d.getTime(),
            //IMAGE
            imageUploaded: false,
            //imageUrl: template.imageUrl,
            designImageUrl: this.state.template.imageUrl,
            designUpdated: now,
            //T-SHIRTS
            shirtColor: 'blank',
            shirtSize: 'blank',
            // shirtText: 'blank',
            shirtText: 'template - ' + this.state.template.idtemplates,
            shirtBackText: 'none',
            shirtType: 'blank',
            description: newDescription,
            order_num: tempOrderNum,
            shirtSizeAndQtys: '',
            itemCode: this.state.itemCode,
            couponCode: this.state.couponCode
        }

        //TOTAL SHIRTS
        let tempTotalShirts = 0;

        //GET ORDERED BY
        let enteredBy = 'normalUser@printboda.com';
        if (this.state.user !== '' && this.state.user.email) {
            console.log("ux1 user.email is valid and there:" + this.state.user.email);
            enteredBy = this.state.user.email;
        }

        /**
         * ORDER 1
         */
        let order1 = {};
        if (this.state.shirtColor1 != '' && this.state.shirtSize1 != '' && this.state.shirtType1 != '' && this.state.qty1 != '') {
            console.log("order 2 is valid");
            order1.shirtColor = this.state.shirtColor1;
            order1.shirtSize = this.state.shirtSize1;
            order1.shirtType = this.state.shirtType1;
            order1.qty = this.state.qty1
            //  newOrder.order1 = order1;
            //tempNumOrders++;
            tempTotalShirts += parseInt(order1.qty);

            //CHECK FOR MONTH
            if (this.state.monthSelected1 !== '') {
                order1.templateText = this.state.monthSelected1;
            }

            //add template text when not month
            if (this.state.templateGenericField1 !== '') {
                order1.templateText = this.state.templateGenericField1;
            }

            //GET SPECIAL TEXT

            //ADD DESCRIPTIONS
            newDescription += this.getOrderDescription(order1, this.state.itemSelected) + " and ";
            console.log("dx1 newDescription:" + newDescription);

            newOrder.order1 = order1;
        }

        /**
         * ORDER 2
         */
        let order2 = {};
        if (this.state.shirtColor2 != '' && this.state.shirtSize2 != '' && this.state.shirtType2 != '' && this.state.qty2 != '') {
            console.log("order 2 is valid");
            order2.shirtColor = this.state.shirtColor2;
            order2.shirtSize = this.state.shirtSize2;
            order2.shirtType = this.state.shirtType2;
            order2.qty = this.state.qty2
            newOrder.order2 = order2;
            // tempNumOrders++;
            tempTotalShirts += parseInt(order2.qty);

            //CHECK FOR MONTH
            if (this.state.monthSelected2 !== '') {
                order2.templateText = this.state.monthSelected2;
            }

            //add template text when not month
            if (this.state.templateGenericField2 !== '') {
                order2.templateText = this.state.templateGenericField2;
            }

            //ADD DESCRIPTIONS
            newDescription += this.getOrderDescription(order2, this.state.itemSelected) + " and ";
            console.log("dx1 newDescription:" + newDescription);
        }

        /**
         * ORDER 3
         */
        let order3 = {};
        if (this.state.shirtColor3 != '' && this.state.shirtSize3 != '' && this.state.shirtType3 != '' && this.state.qty3 != '') {
            console.log("order 2 is valid");
            order3.shirtColor = this.state.shirtColor3;
            order3.shirtSize = this.state.shirtSize3;
            order3.shirtType = this.state.shirtType3;
            order3.qty = this.state.qty3
            newOrder.order3 = order3;

            //tempNumOrders++;
            tempTotalShirts += parseInt(order3.qty);

            if (this.state.monthSelected3 !== '') {
                order3.templateText = this.state.monthSelected3;
            }

            //add template text when not month
            if (this.state.templateGenericField3 !== '') {
                order3.templateText = this.state.templateGenericField3;
            }

            //ADD DESCRIPTIONS
            newDescription += this.getOrderDescription(order2, this.state.itemSelected) + " and ";
            console.log("dx1 newDescription:" + newDescription);
        }

        newOrder.numOrders = this.state.numOrders;
        console.log("tempNumOrders:" + tempNumOrders);


        newOrder.totalShirts = this.countTotalShirts();
        console.log("tempNumOrders:" + tempNumOrders);

        //SET DESCRIPTION
        newOrder.description = newDescription;

        // this.setState({numOrders:tempNumOrders});

        return newOrder;
    }

    /**
* GET DESCRIPTION OF ORDER
* 
*/
    getOrderDescription = (order, itemType) => {
        console.log("+++++++++++:getOrderDescription");
        console.log("itemType:" + itemType);

        let description = this.state.name
            + ' ordered template';

        let orderOne = '';

        orderOne =
            order.qty + ' '
            + order.shirtColor + ' '
            + order.shirtSize + ' '
            + order.teamSelection + ' '
            + ' template '
            //    + ' with name: ' + order.jerseyName 
            //    + ' and number : ' + order.jerseyNumber 
            + ' ' + '" ';

        return orderOne;
    }

    amp_logOrderPlaced = (itemOrdered) => {

        //let eventProperties = {};
        var eventProperties = {
            itemType: 'template',
            itemOrdered: this.state.template.idtemplates,
            // quantity: this.state.quantity,
            // shirtColor: this.state.shirtColor,
            // shirtSize: this.state.shirtSize,
            // shirtType: this.state.shirtType,
            imageUploaded: false,
            admin: this.state.admin,
            totalShirts: this.getNewOrderObject().totalShirts,
            numOrders: this.state.numOrders,
        }


        this.facebookLogOrderPlaced();

    }


    /**
   * UPDATE THE SINGLE ORDER ARRAY
   */
    updateSingleOrderArray = (sentSingleOrderArray) => {
        console.log("main: +++++++++updateSingleOrderArray");
        console.log("sentSingleOrderArrays:" + sentSingleOrderArray.length);

        this.setState({
            singleOrderArray: sentSingleOrderArray,
            numOrders: sentSingleOrderArray.length
        })

        console.log("ssi5: whote shit:" + JSON.stringify(sentSingleOrderArray, null, 3));
    }

    saveAllSingleOrders = (mainOrderKey) => {
        console.log("ssi1 ++++++++++++ saveAllSingleOrders");
        console.log("ssi10 singleOrderArray size:" + this.state.singleOrderArray.length);
        console.log("ssi12 mainOrderKey:" + mainOrderKey);
        this.state.singleOrderArray.map((singleOrder) => {

            let singleOrderKey = ref.child('orders/' + mainOrderKey + '/singleOrders').push().key;

            // let singleOrderKey = ref.child('orders/' + mainOrderKey+ '/singleOrders'.push().key);
            console.log("ssi2 singleOrderKey:" + singleOrderKey);
            // this.setState({ newPostKey: newPostKey });

            ref.child('orders/' + mainOrderKey + '/singleOrders/' + singleOrderKey).set(singleOrder);

        })

        //  history.push('/OrderComplete')
    }

    /**
     * GET THE TOTAL NUMBER OF SHIRTS IN THE ORDER
     */
    countTotalShirts = () => {
        console.log("tx1 +++++++ - count total shirts");

        let totalShirts = 0;

        //check if array exists
        if (this.state.singleOrderArray) {
            this.state.singleOrderArray.map((order) => {
                totalShirts += parseInt(order.qty);
                console.log("total is now:" + totalShirts);
            })
        } else {
            console.log("singleOrderArray not initialized yet");
        }


        console.log("tx2 total is now:" + totalShirts);
        return totalShirts;
    }

    handleOrderDetailsDropDownChanges = (value) => {
        console.log('gbv1 You\'ve sss:', value);
        console.log('gbv12 You\'ve selected:', value.value + " " + value.category);

        let newState = {};
        newState[value.category] = value.value;

        this.setState(newState);
    }

    /**
    * VALIDATE FORM
    */
    validateForm = () => {
        console.log("vll1 validateForm.....");

        let eventProperties = {
            itemType: this.state.itemSelected,
            imageUploaded: this.state.uploadComplete,
            admin: this.state.admin,
            totalShirts: this.getNewOrderObject().totalShirts,
            numOrders: this.state.numOrders,
        }

        //CHECK QUANTITY
        let tempFormHasError = false;
        let tempFormErrors = [];
        let tempFormErrorFieldArray = [];
        let temp_shirtSizeError = false;
        let temp_shirtColorError = false;
        let temp_shirtTypeError = false;

        console.log("quantity:" + this.state.quantity);


        /**
         * PHONE
         */
        if (!this.state.phone || this.state.phone === undefined || this.state.phone === '' || this.state.phone.length !== 10) {
            tempFormHasError = true;
            console.log("phone error");
            //add to field list
            tempFormErrorFieldArray['phone'] = true;

            //ADD TO ARRAY
            tempFormErrors.push("Invalid Phone number, must be 10 digits");
        }

        /**
         * ADDRESS
         */
        if (!this.state.address || this.state.address === undefined || this.state.address === '' || this.state.phone.length < 6) {
            tempFormHasError = true;
            console.log("address error");
            //add to field list
            tempFormErrorFieldArray['address'] = true;

            //ADD TO ARRAY
            tempFormErrors.push("Invalid Address");
        }

        /**
         * NAME
         */
        if (!this.state.name || this.state.name === undefined || this.state.name === '' || this.state.name.length < 4) {
            tempFormHasError = true;
            console.log("address error");
            //add to field list
            tempFormErrorFieldArray['name'] = true;

            //ADD TO ARRAY
            tempFormErrors.push("Invalid Name");
        }

        /**
         * SHIRT COLOR
         */
        //if (!this.state.shirtColor || this.state.shirtColor === undefined || this.state.shirtColor === '') {
        // if (!this.state.shirtColor1 || this.state.shirtColor1 === undefined || this.state.shirtColor1 === '') {
        //     tempFormHasError = true;
        //     console.log("shirtColor1 error");
        //     //add to field list
        //     tempFormErrorFieldArray['shirtColor1'] = true;
        //     temp_shirtColorError = true;

        //     //ADD TO ARRAY
        //     tempFormErrors.push("Please select shirt Color");
        // }

        /**
         * SHIRT SIZE
         */
        // if (!this.state.shirtSize || this.state.shirtSize === undefined || this.state.shirtSize === '') {
        // if (!this.state.shirtSize1 || this.state.shirtSize1 === undefined || this.state.shirtSize1 === '') {
        //     tempFormHasError = true;
        //     console.log("shirtSize1 error");
        //     //add to field list
        //     tempFormErrorFieldArray['shirtSize1'] = true;
        //     temp_shirtSizeError = true;

        //     //ADD TO ARRAY
        //     tempFormErrors.push("Please select Shirt Size");
        // }

        /**
         * SHIRT TYPE
         */
        //if (!this.state.shirtType || this.state.shirtType === undefined || this.state.shirtType === '') {
        // if (!this.state.shirtType1 || this.state.shirtType1 === undefined || this.state.shirtType1 === '') {
        //     tempFormHasError = true;
        //     console.log("shirtType1 error");
        //     //add to field list
        //     tempFormErrorFieldArray['shirtType1'] = true;
        //     temp_shirtTypeError = true;

        //     //ADD TO ARRAY
        //     tempFormErrors.push("Please select Shirt Type");
        // }

        this.setState({
            formHasError: tempFormHasError,
            formErrors: tempFormErrors,
            formErrorFieldArray: tempFormErrorFieldArray,
            shirtColorError: temp_shirtColorError,
            shirtSizeError: temp_shirtSizeError,
            shirtTypeError: temp_shirtTypeError
        })

        console.log("vll12 errorFound:" + tempFormHasError);

        if (!tempFormHasError) {
            console.log("no errors submitting form");
            //this.saveOrder();
            //CONFIRM ORDER
            this.saveOrder();
        } else {

            let errorString = JSON.stringify(tempFormErrorFieldArray);
            console.log("errorString:" + errorString);

            let eventProperties = {
                itemType: this.state.itemSelected,
                admin: this.state.admin,
                error: errorString
            }

            console.log("form error, not submitting form");
        }
    }



    render() {

        const showSingleOrderArray = this.state.templateComponents.length > 0
            ? <SingleOrderFromArray
                itemSelected={this.state.itemSelected} //done
                formErrorFieldArray={this.state.formErrorFieldArray}
                //UPDATE ORDER ARRAY
                updateSingleOrderArray={this.updateSingleOrderArray}
                visible={true}
                //TEMPLATE
                template={true}
                monthSelected={this.state.monthSelected}
                selectDateTemplate={this.state.selectDateTemplate}
                monthTemplate={this.state.monthTemplate}
                templateGenericFieldName={'templateGenericField'}
                templateGenericField={this.state.templateGenericField}
                templateSpecialFieldLabel={this.state.templateSpecialFieldLabel}
                ivanDescription={this.state.ivanDescription}

                shirtSizes={shirtSizes}
                //FACESHIRTS
                faceShirt={this.state.faceShirt}
                admin={this.props.admin}
                //TEMPLATE COMPONENTS
                templateComponents={this.state.templateComponents}
                templateComponentComposite={this.state.templateComponentComposite}
                siniya={this.state.siniya}
                sentTemplate={this.state.template}
            />
            : ''

        const siniyaHeaderAdder = this.state.siniya
            ? <Header as='h3' color='red' textAlign='center'>
                {' '}Please add 10,000 UGX or more for Siniya Activities
        </Header>
            : ''

        const replacementReason = this.state.replacement === 'yes'
            ?
            <Select
                value={this.state.replacementReason}
                options={replacementReasonOptions}
                onChange={this.handleOrderDetailsDropDownChanges}
                searchable={false}
                clearable={false}
            />
            : ''

        /**
         * UI FOR REPLACEMENT & ORDER SOURCE
         */
        const replacementOrderSource = this.state.admin
            ? <div>

                {/* NEW ORDER SMS */}
                <Label pointing='below' color='blue'>{'SEND SMS?'}</Label>
                <Select
                    name="form-field-name"
                    value={this.state.sendNewOrderSms}
                    options={sendNewOrderSmsOptions}
                    onChange={this.handleOrderDetailsDropDownChanges}
                    searchable={false}
                    clearable={false}
                />

                {/* REPLACEMENT */}
                <Label pointing='below' color='blue'>{'REPLACEMENT ORDER?'}</Label>
                <Select
                    name="form-field-name"
                    value={this.state.replacement}
                    options={replacementOptions}
                    onChange={this.handleOrderDetailsDropDownChanges}
                    searchable={false}
                    clearable={false}
                />
                <br />

                {/* REPLACEMENT REASON */}
                {replacementReason}

                {/* ORDER SOURCE */}
                <Label pointing='below' color='blue'>{'ORDER SOURCE?'}</Label>
                <Select
                    name="form-field-name"
                    value={this.state.orderSource}
                    options={orderSourceOptions}
                    onChange={this.handleOrderDetailsDropDownChanges}
                    searchable={false}
                    clearable={false}
                />
                <br />
            </div>
            : ''


        const pricingNotes = this.state.admin
            ? <Form.Field>
                <label>Any Special Pricing Notes </label>
                <Form.TextArea
                    name={'pricing_notes'}
                    value={this.state.pricing_notes}
                    placeholder='Special Pricing:'
                    onFocus={this.amp_logFieldClick}
                    onChange={this.handleTextInputChange}
                    error={this.state.formErrorFieldArray['pricing_notes']}
                />
            </Form.Field>
            : ''

        /**
* UI FOR ORDER TYPE
*/
        const setOrderTypeDropdown = this.state.admin
            ? <div>
                {/* REPLACEMENT */}
                <Label pointing='below' color='blue'>{'ORDER TYPE?'}</Label>
                <Select
                    name="form-field-name"
                    value={this.state.orderType}
                    options={orderTypeOptions}
                    onChange={this.handleOrderDetailsDropDownChanges}
                    searchable={false}
                    clearable={false}
                />
                <br />
            </div>
            : ''

        const setGenderDropdown = this.state.admin
            ? <div>
                {/* REPLACEMENT */}
                <Label pointing='below' color='blue'>{'GENDER'}</Label>
                <Select
                    name="form-field-name"
                    value={this.state.gender}
                    options={genderOptions}
                    onChange={this.handleOrderDetailsDropDownChanges}
                    searchable={false}
                    clearable={false}
                />
                <br />
            </div>
            : ''

        /**
* UI FOR REPLACEMENT & ORDER SOURCE
*/
        const setSalesPersonDropDown = this.state.admin
            ? <div>
                {/* REPLACEMENT */}
                <Label pointing='below' color='blue'>{'SALES PERSON?'}</Label>
                <Select
                    name="form-field-name"
                    value={this.state.salesPerson}
                    options={this.state.salesPeopleChoices}
                    onChange={this.handleOrderDetailsDropDownChanges}
                    searchable={false}
                    clearable={false}
                />
                <br />
            </div>
            : ''

        return (

            this.state.loading ? <UiConsts.LoadingComponent /> :
                <div>
                    <Grid
                        textAlign='center'
                        // style={{ height: '100%' }}
                        verticalAlign='middle' >
                        <Grid.Column style={{ maxWidth: 500 }}>
                            <Image src={require('../../../images/printboda_logo.png')} />
                            <Header as='h2' color='blue' textAlign='center'>
                                {/* {' '}Get this item for just @ {this.state.template.cost} UGX ea */}
                                {' '} Get these items for just  {this.state.template.cost} UGX
                            </Header>
                            {siniyaHeaderAdder}
                            <Image align='center' src={this.state.template.imageUrl} />

                            <Form onSubmit={this.validateForm}>

                                {showSingleOrderArray}

                                {/* <SingleOrderFromArray
                                    itemSelected={this.state.itemSelected} //done
                                    formErrorFieldArray={this.state.formErrorFieldArray}
                                    //UPDATE ORDER ARRAY
                                    updateSingleOrderArray={this.updateSingleOrderArray}
                                    visible={true}
                                    //TEMPLATE
                                    template={true}
                                    monthSelected={this.state.monthSelected}
                                    selectDateTemplate={this.state.selectDateTemplate}
                                    monthTemplate={this.state.monthTemplate}
                                    templateGenericFieldName={'templateGenericField'}
                                    templateGenericField={this.state.templateGenericField}
                                    templateSpecialFieldLabel={this.state.templateSpecialFieldLabel}
                                    shirtSizes={shirtSizes}
                                    //FACESHIRTS
                                    faceShirt={this.state.faceShirt}
                                    admin={this.props.admin}
                                    //TEMPLATE COMPONENTS
                                    templateComponents = {this.state.templateComponents}
                                /> */}


                                {/* NAME */}
                                <Form.Field>
                                    <label>Your Name</label>
                                    <Form.Input
                                        fluid
                                        name={'name'}
                                        value={this.state.name}
                                        icon='add user'
                                        iconPosition='left'
                                        placeholder='Name'
                                        onFocus={this.amp_logFieldClick}
                                        onChange={this.handleTextInputChange}
                                        error={this.state.formErrorFieldArray['name']}
                                    />
                                </Form.Field>

                                {/* PHONE */}
                                <Form.Field>
                                    <label>Phone #1 (Whatsapp)</label>
                                    <Form.Input
                                        fluid
                                        name={'phone'}
                                        value={this.state.phone}
                                        icon='phone'
                                        iconPosition='left'
                                        placeholder='Phone Number'
                                        onFocus={this.amp_logFieldClick}
                                        onChange={this.handleTextInputChange}
                                        control='input'
                                        type='number'
                                        error={this.state.formErrorFieldArray['phone']}
                                    />
                                </Form.Field>

                                {/* PHONE #2 */}
                                <Form.Field>
                                    <label>Phone #2</label>
                                    <Form.Input
                                        fluid
                                        name={'phone2'}
                                        value={this.state.phone2}
                                        icon='phone'
                                        iconPosition='left'
                                        placeholder='Phone Number #2'
                                        onFocus={this.amp_logFieldClick}
                                        onChange={this.handleTextInputChange}
                                        control='input'
                                        type='number'
                                        error={this.state.formErrorFieldArray['phone2']}
                                    />
                                </Form.Field>

                                {/* EMAIL */}
                                <Form.Field>
                                    <label>Email</label>
                                    <Form.Input
                                        fluid
                                        name={'email'}
                                        value={this.state.email}
                                        icon='user'
                                        iconPosition='left'
                                        placeholder='Email'
                                        onFocus={this.amp_logFieldClick}
                                        onChange={this.handleTextInputChange}
                                        control='input'
                                        type='email'
                                    />
                                </Form.Field>

                                {/* DELIVERY ADDRESS */}
                                <Form.Field>
                                    <label>Full Delivery Address:(Street or Road, Plot Number, Building, Any landmarks) </label>
                                    <Form.TextArea
                                        name={'address'}
                                        value={this.state.address}
                                        placeholder='Full Delivery Address:'
                                        onFocus={this.amp_logFieldClick}
                                        onChange={this.handleTextInputChange}
                                        error={this.state.formErrorFieldArray['address']}
                                    />
                                </Form.Field>

                                {/* SPECIAL DIRECTIONS */}
                                <Form.Field>
                                    <label>Any Special Instructions for your order? </label>
                                    <Form.TextArea
                                        name={'special_instructions'}
                                        value={this.state.special_instructions}
                                        placeholder='Special Instructions:'
                                        onFocus={this.amp_logFieldClick}
                                        onChange={this.handleTextInputChange}
                                        error={this.state.formErrorFieldArray['special_instructions']}
                                    />
                                </Form.Field>

                                {/* coupon */}
                                {/* <Form.Field>
                                    <label>Coupon Code (Do you have a discount code sent to you via sms?)</label>
                                    <Form.Input
                                        fluid
                                        name={'couponCode'}
                                        value={this.state.couponCode}
                                        icon='money'
                                        iconPosition='left'
                                        placeholder='Coupon / Discount Coude'
                                        onFocus={this.amp_logFieldClick}
                                        onChange={this.handleTextInputChange}
                                        control='input'
                                        type='text'
                                    />
                                </Form.Field> */}

                                {pricingNotes}

                                {/* {setOrderTypeDropdown} */}

                                {/* SET GENDER TYPE */}
                                {/* {setGenderDropdown} */}

                                {/* REPLACEMENT */}
                                {replacementOrderSource}

                                {/* {setSalesPersonDropDown} */}

                                <Button color='blue' fluid size='large'>ORDER</Button>

                                <br />
                                <ErrorMessages
                                    formHasError={this.state.formHasError}
                                    formErrors={this.state.formErrors} />
                                <Button type='button' color='teal' fluid size='large'>BACK</Button>
                            </Form>

                            <br />
                        </Grid.Column>
                    </Grid>
                </div>
        )
    }
}

export default TemplateOrderForm;


// WEBPACK FOOTER //
// ./src/components/newSite/templates/TemplateOrderForm.js